import { EMPTY_TABLE_MESSAGE, PIPELINE_TYPES } from "@via/utils/constants.tsx";
import { EmptyDataIcon } from "@via/utils/custom-icons";
import {
  PipelineInterface,
  PipelineListProps,
} from "@via/utils/interfaces.tsx";
import TagsCell from "@via/components/tags-cell.tsx";
import { type JSX } from "react";
import { Link } from "react-router-dom";
import "../pipelines/pipelines.css";
import Logo from "/logo.svg";
import NFCoreLogo from "/nf-core.png";
import AiBadge from "@via/components/ai-badge";

export default function PipelineGlossary({ pipelines }: PipelineListProps) {
  const getPipelineLogo = (type: string): JSX.Element => {
    return type === PIPELINE_TYPES.NFCORE ? (
      <img src={NFCoreLogo} className="h-8 pr-4" alt="NF-Core Logo" />
    ) : (
      <img src={Logo} className="h-8 pr-4" alt="Foundry Connect logo" />
    );
  };
  return (
    <>
      {pipelines?.length === 0 && (
        <div className="via-generic-error">
          <EmptyDataIcon />
          <p>{EMPTY_TABLE_MESSAGE.PIPELINES}</p>
        </div>
      )}
      {pipelines?.length > 0 && (
        <ul
          role="list"
          className="grid grid-cols-1 gap-6 py-6 sm:grid-cols-2 lg:grid-cols-3">
          {pipelines?.map((pipeline: PipelineInterface) => (
            <Link
              to={`${pipeline.id}`}
              data-testid={`pipeline-grid-${pipeline.id}`}
              key={pipeline.id}>
              <li
                title={pipeline.summary}
                className="duration-175 h-52 cursor-pointer divide-y divide-gray-200 rounded-lg bg-white text-left drop-shadow-md transition hover:drop-shadow-lg focus:border-blue-300 focus:outline-2 focus:ring">
                <div className="flex justify-between p-4">
                  {getPipelineLogo(pipeline.pipelineType)}
                  <div className="flex-1">
                    <div className="flex flex-row justify-between space-x-3">
                      <h3 className="text-md font-semibold text-gray-900">
                        {pipeline.name}
                      </h3>
                      {Boolean(pipeline?.aiEntity) && <AiBadge />}
                    </div>
                    <p className="line-clamp-card mt-1 max-w-[300px] text-sm text-gray-500">
                      {pipeline.summary}
                    </p>
                  </div>
                </div>
                {pipeline.tags && pipeline.tags.length > 0 && (
                  <div className="p-3">
                    <TagsCell
                      tags={pipeline.tags}
                      rowId={pipeline.id}
                      variant="card"
                    />
                  </div>
                )}
              </li>
            </Link>
          ))}
        </ul>
      )}
    </>
  );
}
